import type { QueryItem } from '../../types';

const NAME = 'isChildSingleTextBlockEmpty';
const isChildSingleTextBlockEmpty: QueryItem =
  ({ editorQuery }) =>
  (nodeId: string) => {
    if (editorQuery.query.isMultipleSelection()) {
      return false;
    }
    const selectedNode = editorQuery
      .selection()
      .doc?.children?.[0]?.descendants((node: $TSFixMe) => node.toNode()?.id === nodeId)[0];
    if (selectedNode?.children.length !== 1) {
      return false;
    }
    return selectedNode.children[0].node.textContent === '';
  };

export default { NAME, query: isChildSingleTextBlockEmpty };
